module.exports = __webpack_public_path__ + "img/setting.a98f7bc1.svg";